import { inject, Injectable, OnDestroy } from '@angular/core';

import { UserStore } from '@zeusm/shared/session/user';

/**
 * Service to synchronize authentication state across multiple browser tabs
 * Uses BroadcastChannel API for modern browsers
 */
@Injectable({ providedIn: 'root' })
export class AuthSyncService implements OnDestroy {
  private readonly userStore = inject(UserStore);
  private readonly channel: BroadcastChannel;

  constructor() {
    // Create a broadcast channel for cross-tab communication
    this.channel = new BroadcastChannel('auth-channel');

    // Listen for messages from other tabs
    this.channel.onmessage = event => {
      if (event.data === 'logout') {
        // Another tab logged out, clear user data
        this.#handleLogout();
      } else if (event.data === 'login') {
        // Another tab logged in, fetch user data
        this.#handleLogin();
      }
    };
  }

  /**
   * Notify other tabs that user has logged out
   */
  notifyLogout(): void {
    this.channel.postMessage('logout');
  }

  /**
   * Clean up resources when service is destroyed
   */
  ngOnDestroy(): void {
    this.channel.close();
  }

  /**
   * Handle logout in this tab (triggered by another tab)
   */
  #handleLogout(): void {
    // Clear user store state
    this.userStore.getMe(); // This will fail and update state accordingly

    // Optionally redirect to login page
    // window.location.href = '/signin';
  }

  /**
   * Handle login in this tab (triggered by another tab)
   */
  #handleLogin(): void {
    // Fetch fresh user data
    this.userStore.getMe();
  }
}
